import { useEffect, useState } from 'react'

import { Link } from 'react-router-dom'

import { initFlowbite } from 'flowbite'

import { pageService } from 'services'

import { Pagination } from 'components'
import AddNewDealModal from 'components/modal/add-deal'

import { routes } from 'utils/routes'
import { _object } from 'utils/interfaces'

import { DeleteIcon, EditIcon, ViewIcon } from 'assets/svg'

const Pages = () => {
  const [loading, setLoading] = useState(false)
  const [results, setResults] = useState<_object>({})
  const [loadAgain, setLoadAgain] = useState(false)
  const [filters, setFilters] = useState<_object>({
    q: '',
    page: 1,
    per_page: 25,
    sort: ''
  })

  useEffect(() => {
    initFlowbite()
  }, [])

  useEffect(() => {
    setLoading(true)
    pageService.getPages(filters).then((results) => {
      setResults(results)
      setLoading(false)
    })
  }, [filters, loadAgain])

  const deletePage = (id: string) => {
    if (window.confirm('Are you sure you want to delete?')) {
      pageService.deletePage(id).then((results: _object) => {
        if (results?.error === false) {
          setLoadAgain(true)
        }
      })
    }
  }

  return (
    <>
      <div className="mb-6 flex items-center justify-between">
        <h1 className="text-2xl font-semibold">
          Pages <small>Total records: {results?.pagination?.total_items}</small>
        </h1>
        <Link
          to={routes.addPage}
          className="rounded-md border border-purple-900 bg-purple-900 px-4 py-2 text-sm font-medium text-white hover:bg-purple-950"
        >
          Add New Page
        </Link>
      </div>

      <div className="overflow-x-auto rounded-lg bg-white shadow">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-100">
            <tr className="text-left text-sm font-medium text-gray-900">
              <th className="px-4 py-3 font-semibold">#</th>
              <th className="px-4 py-3 font-semibold">Name</th>
              <th className="px-4 py-3 font-semibold">Slug</th>
              {/* <th className="px-4 py-3 font-semibold">Short Description</th> */}
              <th className="px-4 py-3 font-semibold">Status</th>
              <th className="px-4 py-3 text-center font-semibold">Action</th>
            </tr>
          </thead>

          <tbody className="divide-y divide-gray-100 text-sm">
            {loading === false ? (
              results?.items?.map((item: _object, i: number) => (
                <tr className="hover:bg-gray-50" key={i}>
                  <td className="px-4 py-3">{i + 1}</td>
                  <td className="px-4 py-3">{item?.title}</td>
                  <td className="px-4 py-3">{item?.slug}</td>
                  {/* <td className="px-4 py-3">{item?.short_description}</td> */}
                  <td className="px-4 py-3">{item?.status}</td>

                  <td className="flex justify-center gap-2 px-4 py-3">
                    <Link
                      to={`https://treasuresunlimited.vercel.app/${item.slug}`}
                      target="blank"
                      title="View Page"
                    >
                      <ViewIcon className="h-[20px] w-[20px]" />
                    </Link>
                    <Link to={`${routes.pages}/${item.id}`} title="Edit Page">
                      <EditIcon />
                    </Link>
                    <button type="button" onClick={() => deletePage(item.id)} title="Delete Page">
                      <DeleteIcon className="h-[20px] w-[20px]" />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <PageSkeleton />
            )}
            {results?.items?.length <= 0 && <p> No record found</p>}
          </tbody>
        </table>
      </div>

      {results?.pagination?.total_pages > 1 && (
        <Pagination
          pageCount={results?.pagination?.total_pages}
          current_page={results?.pagination?.current_page}
          onPageChange={(e: _object) => {
            setFilters({ ...filters, page: e.selected + 1 })
          }}
        />
      )}
      <AddNewDealModal />
    </>
  )
}
export default Pages

const PageSkeleton = () => {
  return (
    <tr className="animate-pulse">
      <td className="px-4 py-3">
        <div className="h-4 w-6 rounded bg-gray-300"></div>
      </td>
      <td className="px-4 py-3">
        <div className="h-4 w-32 rounded bg-gray-300"></div>
      </td>
      <td className="px-4 py-3">
        <div className="h-4 w-12 rounded bg-gray-300"></div>
      </td>
      <td className="px-4 py-3">
        <div className="h-4 w-8 rounded bg-gray-300"></div>
      </td>

      <td className="flex justify-center gap-2 px-4 py-3">
        <div className="h-5 w-5 rounded-full bg-gray-300"></div>
        <div className="h-5 w-5 rounded-full bg-gray-300"></div>
        <div className="h-5 w-5 rounded-full bg-gray-300"></div>
      </td>
    </tr>
  )
}
